import {
    Grid,
    Slider,
    SxProps,
    Theme,
    Typography,
    useTheme,
} from "@mui/material";
import React from "react";

interface OwnProps {
    label?: string;
    value: number | number[];
    description?: string;
    onChange?: any;
    minValue?: number;
    maxValue?: number;
    step?: number;
    noValueLabel?: string;
    underSlideLabel?: string;
    sx?: SxProps<Theme>;
    labelSx?: SxProps<Theme>;
    descriptionSx?: SxProps<Theme>;
    disabled?: boolean;
}

const AcxSlider = (props: OwnProps) => {
    const theme = useTheme();

    const handleChange = (event, newValue) => {
        props.onChange(newValue);
    };

    const isRangeSlider = Array.isArray(props.value);

    const startValue = isRangeSlider ? props.value?.[0] : props.value;
    const endValue = isRangeSlider ? props.value?.[1] : props.value;

    const endValueIsNotZero = endValue !== 0;

    const startValueString = startValue?.toString();
    const endValueString = endValue?.toString();

    const underSliderLabel = `${startValueString} ${
        isRangeSlider ? `- ${endValueString}` : ""
    } ${props.description}`;

    return (
        <Grid>
            <Typography id="slider-label" sx={props.labelSx}>
                {props.label}
            </Typography>
            <Slider
                value={props.value}
                onChange={handleChange}
                aria-labelledby="slider-label"
                disabled={props.disabled}
                sx={[
                    {
                        height: 8,
                        ".MuiSlider-thumb": {
                            height: 10,
                            width: 10,
                            backgroundColor: theme.palette.white.main,
                            border: "2px solid currentColor",
                            "&:focus, &:hover, &$active": {
                                boxShadow: "inherit",
                            },
                            "&::after": {
                                width: "30px", // reduce slider thumb width to avoid horizontal overflow in conversations
                            },
                        },
                        active: {},
                        ".MuiSlider-track": {
                            height: 8,
                            borderRadius: 4,
                        },
                        ".MuiSlider-rail": {
                            height: 8,
                            borderRadius: 4,
                            color: theme.palette.gray.main,
                        },
                    },
                    ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
                ]}
                min={props.minValue}
                max={props.maxValue}
                step={props.step || 1}
            />
            <Typography sx={props.descriptionSx}>
                {endValueIsNotZero
                    ? props.underSlideLabel ?? underSliderLabel
                    : props.noValueLabel ?? "Any"}
            </Typography>
        </Grid>
    );
};

export default AcxSlider;
